import { render, staticRenderFns } from "./registerThree.vue?vue&type=template&id=275b7532&scoped=true&"
import script from "./registerThree.vue?vue&type=script&lang=js&"
export * from "./registerThree.vue?vue&type=script&lang=js&"
import style0 from "./registerThree.vue?vue&type=style&index=0&id=275b7532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275b7532",
  null
  
)

export default component.exports